import "./InflatableMechanicalBulls.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Advisory from "./sections/Advisory";
import InflatableBull from "./sections/InflatableBull";
import Evaluate from "./sections/Evaluate";
import PackageContents from "./sections/PackageContents";
import Arena from "./sections/Arena";
import BlowerGuide from "./sections/BlowerGuide";
import SpaceGuide from "./sections/SpaceGuide";
import SelectionGuide from "./sections/SelectionGuide";
import Comparison from "./sections/Comparison";
import CostOverview from "./sections/CostOverview";
import Checklist from "./sections/Checklist";
import Compatibility from "./sections/Compatibility";
import Shipping from "./sections/Shipping";
import InflatableFaq from "./sections/InflatableFaq";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function InflatableMechanicalBullsPage() {
  return <div>
      <Header />
      <Hero />
      <Advisory />
      <InflatableBull />
      <Evaluate />
      <PackageContents />
      <Arena />
      <BlowerGuide />
      <SpaceGuide />
      <SelectionGuide />
      <Comparison />
      <CostOverview />
      <Checklist />
      <Compatibility />
      <Shipping />
      <InflatableFaq />
      <Cta />
      <Footer />
    </div>;
}